import { Pipe, PipeTransform } from "@angular/core";
import { ClienteDTO } from "@DTOS";

@Pipe({
    name: "filtrarTabla"
})
export class FiltrarTablaPipe implements PipeTransform {
    transform(clientes: ClienteDTO[], filtro: string): ClienteDTO[] {
        if (!filtro || filtro.length === 0) {
            return clientes;
        }
        if (clientes.length === 0) {
            return clientes;
        }

        return clientes.filter((cliente: ClienteDTO) => {
            const empresa = cliente.nombre.toLowerCase().includes(filtro.toLocaleLowerCase());
            const nombreCompleto = cliente.nombreCompleto?.toLowerCase().includes(filtro.toLocaleLowerCase());

            if (empresa || nombreCompleto) {
                return cliente;
            }
        });
    }
}
